import { render, staticRenderFns } from "./user_list.vue?vue&type=template&id=128b780c&scoped=true&"
import script from "./user_list.vue?vue&type=script&lang=js&"
export * from "./user_list.vue?vue&type=script&lang=js&"
import style0 from "./user_list.vue?vue&type=style&index=0&id=128b780c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b780c",
  null
  
)

export default component.exports